import HttpRequest from './HttpRequest';

export default class ToppingService extends HttpRequest {
  static endpoint = 'toppings';

  static async getAll() {
    this.endpoint = 'toppings/by-brand';
    const response = await this.get();
    return response;
  }

  static async create(data) {
    this.endpoint = 'toppings';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'toppings';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'toppings';
    const response = await this.delete(id);
    return response;
  }
}
